import React, { useState } from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import BildHeader from "../../images/services/heimberatung/header.jpg"
import BildOben from "../../images/services/heimberatung/oben.jpg"
import Bild1 from "../../images/services/augenpruefung/1.jpg"
import Bild2 from "../../images/services/augenpruefung/2.jpg"
import Bild3 from "../../images/services/augenpruefung/3.jpg"
import Bild4 from "../../images/services/augenpruefung/4.jpg"
import SubNavigation from "../../components/SubNavServices"
import Termin from "../../components/Termin"

const Augenpruefung: React.FC = () => {
  const siteTitle = "Augenprüfung – Dienstleistungen"
  const [isSubMenuOpen, setSubMenuOpen] = useState(false)

  return (
    <Layout title={siteTitle}>
      <SEO title={siteTitle} />
      <section className="wrapper">
        <div className="headerImage">
          <img src={BildHeader} />
        </div>
      </section>
      <Termin />
      <SubNavigation
        isSubMenuOpen={isSubMenuOpen}
        setSubMenuOpen={setSubMenuOpen}
        activeMenuText="Augenprüfung"
      />

      <section className="wrapper greyColor content">
        <h1>Augenprüfung</h1>
        <h2 className="contentSubtitle">SCHWARZ Optik – Seit 1992 in Heiden</h2>
        <div className="contentColumns">
          <div className="contentColumn">
            <div className="imageCollection">
              <div className="imageRow">
                <img src={Bild1} />
              </div>
              <div className="imageRow">
                <img src={Bild2} />
              </div>
            </div>
            <h2>Sehstörungen erkennen – bevor sie zum Problem werden</h2>
            <p>Kopfschmerzen, visuelle Erschöpfung oder Konzentrationsprobleme haben oft eine unsichtbare Ursache: kleine, nicht erkannte Sehdefizite – besonders im beidäugigen Sehen. Nur wenn beide Augen harmonisch zusammenarbeiten, kann das Gehirn ein stabiles Bild erzeugen.</p>
            <div className="imageCollection">
              <div className="imageRow">
                <img src={Bild4} />
              </div>
              <div className="imageRow halfwidth">
                <img src={Bild3} />
              </div>
            </div>
            <p class="imageCaption">Passende Sehhilfen für jede Situation</p>
            <h2>Weitere Leistungen</h2>
            <ul>
              <li>Sehtests für Lernfahr- und Führerausweise</li>
              <li>MFK-gerechte Kontrollen</li>
              <li>gezielte Weiterleitung an Augenärzt:innen bei medizinischem Verdacht</li>
            </ul>
          </div>
          <div className="contentColumn">
            <h2>Gesundheitsoptik beginnt mit Wissen – und mit Präzision</h2>
            <p>
              Als spezialisierter Gesundheitsoptiker mit optometrischer Ausbildung geht unser Anspruch bei SCHWARZ Optik weit über den klassischen Sehtest hinaus. Unsere Augenprüfung ist ein umfassender Gesundheitscheck – individuell, vorausschauend und auf fachlich höchstem Niveau.
            </p>
            <p>
              Wir untersuchen – je nach Bedarf – folgende Bereiche:
            </p>
            <ul>
                <li>die beidäugige Sehfunktion und das Zusammenspiel der Augen</li>
                <li>den vorderen und hinteren Augenabschnitt mittels modernster optometrischer Diagnostik</li>
                <li>den Augeninnendruck (Tonometrie) – berührungsfrei gemessen</li>
                <li>das Gesichtsfeld (Perimetrie)</li>
                <li>das Farbsehen</li>
                <li>die exakte Korrekturbestimmung für Brillen oder Kontaktlinsen</li>
                <li>und bei Bedarf: eine weiterführende optometrische Beratung</li>
            </ul>
            <p>
              Diese ganzheitliche Herangehensweise ermöglicht nicht nur die genaue Bestimmung der Sehschärfe, sondern auch das frühzeitige Erkennen funktioneller Auffälligkeiten oder medizinischer Risiken – bevor Beschwerden entstehen.
            </p>
            <h2>Früh handeln – besonders bei Kindern</h2>
            <p>Gerade bei Kindern bleiben visuelle Probleme lange unbemerkt. Erst wenn schulische, motorische oder soziale Schwierigkeiten auftreten, wird die Verbindung zum Sehen erkannt. Unsere spezialisierten Messverfahren helfen, solche Abweichungen früh zu identifizieren. Wenn nötig, kombinieren wir optometrisches Visualtraining mit individuell abgestimmten Korrekturen.</p>
            <h2>Gesundheitsoptik mit System</h2>
            <p>SCHWARZ Optik steht für fachliche Tiefe, Verantwortung und modernste Technologie. Unsere umfassende Augenprüfung ist ein zentraler Bestandteil unserer optometrischen Dienstleistung – und Grundlage für jedes nachhaltige Seherlebnis.</p>
            <a
              href="https://www.click2date.eu/schwarz-optik.ch"
              target="_blank"
              rel="noreferrer"
              class="btn"
            >
              Augenprüfung bei SCHWARZ Optik – weil gutes Sehen kein Zufall ist.
            </a>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default Augenpruefung
